import Typography from "@mui/material/Typography";
import React from "react";

const CompanyText = ({style = {}, ...props}) => {
    return <Typography align='center' sx={{
        color: 'var(--brand-500)',
        fontWeight: 900,
        fontSize: 25,
        cursor: 'pointer',
        ...style
    }} {...props}>LlamaHaul</Typography>
}

export default CompanyText;